import { createContext, Context } from 'react';
import { ColumnProps } from '../column';

export type TableID = string;

export interface TableConfig {
  visibleColumns?: { [key: string]: boolean };
  selectedRows?: Set<string>;
  columns: ColumnProps[];
  sortKey: string;
  loading?: boolean;
  sortAscending: boolean;
  search: string;
}

// tslint:disable-next-line:interface-name
export interface ITableContext {
  tables: {
    [tableID: string]: TableConfig;
  };
  setInitialConfig?: (tableID: string) => (config: TableConfig) => void;
  toggleColumn?: (tableID: string) => (key: string) => void;
  toggleColumns?: (tableID: string) => (keys: string[]) => void;
  toggleSelect?: (tableID: string) => (rowID: string) => void;
  onSortChange?: (
    tableID: string,
  ) => (sortKey: string, sortAscending: boolean) => void;
  onSearchChange?: (tableID: string) => (search: string) => void;
  selectAll?: (tableID: string) => (rowIDs: string[]) => void;
  deselectAll?: (tableID: string) => () => void;
}

const initialValue: Partial<ITableContext> = {
  tables: {},
};

export default createContext(initialValue);
